import { defineComponent, h } from 'vue';
import './VOverlay.scss';

export default defineComponent({
  render() {
    return h('div', { class: 'v-overlay' });
  },
});
